import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const WarningCircleSolidIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 15"
  >
    <path
      fillRule="evenodd"
      d="M7.05.512a1.85 1.85 0 0 1 2.58.711l5.864 10.891a1.854 1.854 0 0 1-.716 2.488 1.85 1.85 0 0 1-.914.241H2.135a1.854 1.854 0 0 1-1.85-1.81c-.008-.32.068-.636.22-.918L6.37 1.223c.158-.294.393-.54.68-.711m.15 10.46h1.6v1.6H7.2zm1.6-6.4H7.2v4.8h1.6z"
      clipRule="evenodd"
    />
  </svg>
);
WarningCircleSolidIcon.id = 'WarningCircleSolidIcon';
WarningCircleSolidIcon.displayName = 'WarningCircleSolidIcon';
export default WarningCircleSolidIcon;
